import { flattenMessages } from '../../helpers';

import enGlobal from '../global/en.json';
import esGlobal from '../global/es.json';
import ruGlobal from '../global/ru.json';
import zhGlobal from '../global/zh.json';

import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: {
    ...flattenMessages(en, 'home'),
    ...flattenMessages(enGlobal, 'global'),
  },
  es: {
    ...flattenMessages(es, 'home'),
    ...flattenMessages(esGlobal, 'global'),
  },
  ru: {
    ...flattenMessages(ru, 'home'),
    ...flattenMessages(ruGlobal, 'global'),
  },
  zh: {
    ...flattenMessages(zh, 'home'),
    ...flattenMessages(zhGlobal, 'global'),
  },
};
